import { Component, inject, Input, OnInit, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-info-bulle',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent  implements OnInit {
    @Input({ required: true })
    confirmationText: string
    @Input({ required: true })
    modalTitle: string
    @Input()
    centerTitle = false
    @Input()
    bodyAlign: 'start' | 'center' | 'end' = 'center'
    @Input()
    confirmButtonLabel = 'Oui'
    @Input()
    confirmButton2Label: string
    @Input()
    cancelButtonLabel = 'Non'
    @Input()
    tooltip: string
    @Input()
    highlightConfirm = false
    @Input()
    hideConfirmButton = false
    @Input()
    hideCancelButton = false

    protected numberOfActiveButtons = signal<number>(0)
    private modalRef = inject(NgbActiveModal)

    ngOnInit(): void {
        this.numberOfActiveButtons.set(this.computeNumberOfDisplayedButtons())
    }

    onConfirm(): void {
        this.modalRef.close('confirm')
    }

    onConfirm2(): void {
        this.modalRef.close('confirm2')
    }

    onCancel(): void {
        this.modalRef.close('cancel')
    }

    onClose(): void {
        this.modalRef.close('close')
    }

    private computeNumberOfDisplayedButtons(): number {
        let nbOfButtons = 2 // (by default)
        if (this.hideConfirmButton) {
            nbOfButtons--
        }
        if (this.hideCancelButton) {
            nbOfButtons--
        }
        if (this.confirmButton2Label) {
            nbOfButtons++
        }
        return nbOfButtons
    }
}
